export default {
  buttonTransition: {
    transition: 'background 150ms cubic-bezier(0.470, 0.000, 0.745, 0.715), color 150ms cubic-bezier(0.470, 0.000, 0.745, 0.715)'
  },
  rotate180: { transform: 'rotate(180deg)' },
  float: {
    animation: 'float 10s ease-in-out infinite',
    '@keyframes float': {
      '0%': {
        transform: 'translate(0px, 0px)',
      },
      '25%': {
        transform: 'translateX(-100px)',
      },
      '50%': {
        transform: 'translateY(-100px',
      },
      '75%': {
        transform: 'translateX(200px)',
      },
      '100%': {
        transform: 'translate(0px, 0px)',
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/stylesheet/utils.js